import PropTypes from 'prop-types';
import { DeliveryTypes } from 'App/order-fields';
import { AppMode } from 'App/config';
export var appModePropType = PropTypes.oneOf(Object.values(AppMode));
export var deliveryModePropType = PropTypes.oneOf([
    DeliveryTypes.usual,
    DeliveryTypes.takeout,
]);
